import React, { PureComponent } from 'react'
import styled from 'react-emotion'

import { Flex, Box, Icon, Tooltip } from 'shared/ui'
import withMenuPositioning from 'shared/ui/Dropdown/withMenuPositioning'

import ListenToKeyboard from 'components/ListenToKeyboard'
import NavItem from 'components/App/DesktopView/shared/Composer/Email/Header/NavItem'

class Trigger extends PureComponent {
  componentDidMount() {
    const { open } = this.props
    if (open) this.openModal()
  }

  openModal = () => {
    const { right, bottom, top, left } = this.props
    this.props.doShowCannedReplyModal({ offset: { bottom, right, top, left } })
  }

  render() {
    const { active, className } = this.props

    return (
      <Tooltip tooltip="Insert a canned reply [i]" position="top">
        <ListenToKeyboard onI={this.openModal} preventDefault disableForInput />
        <NavItem active={active} className={className} onClick={this.openModal}>
          <Flex flex="1 0 auto">
            <Box>
              <Icon
                color="inherit"
                ml="-4px"
                mr="-4px"
                name="flash_on"
                size="xsmall"
              />
            </Box>
            <Box ml={2}>Insert reply</Box>
          </Flex>
        </NavItem>
      </Tooltip>
    )
  }
}

export default styled(withMenuPositioning(Trigger))`
  .Icon {
    line-height: 24px;
  }
`
